import { signal } from '@angular/core';

import { GridViewType, IGridData } from './types';
import { gridViewKey } from './utils';

export class CamGridView<T extends { id: string }> {
  // Signal : les composants de grille sont OnPush et ne partagent aucun lien parent/enfant.
  private readonly _displayType = signal<GridViewType>('grid');

  public readonly displayType = this._displayType.asReadonly();

  private _userSwitchEnabled = false;

  constructor(private _grid: IGridData<T>) {}

  public enableUserSwitch() {
    this._userSwitchEnabled = true;
    const stored = this._storedView;
    if (stored) {
      this.switchView(stored, false);
    }
  }

  public switchViewDefault(type: GridViewType) {
    this.switchView((this._userSwitchEnabled ? this._storedView : null) ?? type, false);
  }

  private get _storedView(): GridViewType | null {
    return localStorage.getItem(gridViewKey + this._grid.scope) as GridViewType | null;
  }

  public switchView(type: GridViewType, save = true) {
    this._displayType.set(type);
    if (save) {
      localStorage.setItem(gridViewKey + this._grid.scope, type);
    }
  }

  public switchTreeMode(value?: boolean) {
    if (!this._grid.api || !this._grid.isTreeData) {
      return;
    }

    const newValue = value ?? !this._grid.api.getGridOption('treeData');
    this._grid.api.setGridOption('treeData', newValue);
    this._grid.api.refreshServerSide({ purge: true });
  }
}
